import Loader from '@components/shared/loader/Loader';
import { ErrorToast } from '@services/utils/ToastUtils';
import { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  getPrivateIncentiveLookUpData,
  getPrivateIncentiveLookUpDataConquestDashboard,
} from '../../../../../services/api/GenericClient';
import {
  setPrivateIncentiveModalOpen,
  setPrivateIncentiveModalResource,
} from '../../../../../store/portfolio/PortfolioActions';
import { theme } from '../../../../../styles/theme';
import { PrivateIncentiveDetailsProps } from '../../../../../types/PrivateIncentiveLookup';
import PrivateIncentiveLookupSearchResult from '../../../../essential-ui/private-incentive-lookup/PrivateIncentiveLookupSearchResult';
import PrivateIncentiveModalTitle from './PrivateIncentiveModalTitle';

type PrivateIncentiveModalProps = {
  isModalOpen: boolean;
  openModal: (value: boolean) => void;
  lastName?: string;
  vin?: string;
  isLeaseBuyOut?: boolean;
  leadId?: string;
  legacyDealerId?: string;
  privateIncentiveLookupActionType?: string;
};

const PrivateIncentiveModal: FC<PrivateIncentiveModalProps> = (props) => {
  const dispatch = useDispatch();
  const [privateIncentiveDetails, setPrivateIncentiveDetails] = useState<
    PrivateIncentiveDetailsProps[]
  >([]);
  const [isLoading, SetIsloading] = useState(false);
  const mazdaAlternateModelText: string = 'All Eligible Non-Primary Vehicles';
  const handleCloseNotesModal = () => {
    dispatch(
      setPrivateIncentiveModalResource({
        lastName: '',
        vin: '',
        isLeaseBuyOut: false,
        leadId: '',
        legacyDealerId: '',
        privateIncentiveLookupActionType: '',
        leadDealerId: '',
      }),
    );
    dispatch(setPrivateIncentiveModalOpen(false));
  };

  useEffect(() => {
    SetIsloading(true);
    const brands = localStorage.getItem('am.distinctBrands');
    const arrBrands = JSON.parse(brands);
    let brandsInLowerCase = arrBrands.map((b) => {
      if (b.length > 4) {
        b = b.substring(0, 4);
      }
      return b.toLowerCase();
    });

    if (props.leadId && props.leadId.length > 0) {
      getPrivateIncentiveLookUpDataConquestDashboard(
        props.lastName,
        brandsInLowerCase,
        props.leadId,
        props.legacyDealerId,
        props.privateIncentiveLookupActionType,
      ).then((resp) => {
        assignPrivateIncentiveDetails(resp);
      });
    } else {
      getPrivateIncentiveLookUpData(
        props.lastName,
        props.vin,
        '',
        brandsInLowerCase,
        props.privateIncentiveLookupActionType,
        '',
        '',
      ).then((resp) => {
        assignPrivateIncentiveDetails(resp);
      });
    }
  }, []);

  const getMazdaAlternateModelText = (alternateModels: string[]): string[] => {
    for (let index in alternateModels) {
      alternateModels[index] = mazdaAlternateModelText;
    }
    return alternateModels;
  };

  const getAlternateModels = (alternateModels: string[], altIncentiveAmt: number): string[] => {
    if (altIncentiveAmt != 0) return alternateModels;
    else return [];
  };

  const assignPrivateIncentiveDetails = (resp) => {
    if (resp === undefined || resp.length == 0) {
      ErrorToast('Private Incentive details unavailable. Please try later.');
      SetIsloading(false);
      dispatch(setPrivateIncentiveModalOpen(false));
    } else {
      let incentives = (
        resp.length > 1
          ? resp.filter(
              (res) =>
                new Date(res.endDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0),
            )
          : resp
      ).map((item) => {
        return {
          lastName: props.lastName,
          vinCurrentlyOwned: props.vin,
          startDate: item.startDate,
          endDate: item.endDate,
          program: item.oemBulletinName,
          bulletin: item.oemBulletinNumber,
          redemptionCode: item.redemptionCode,
          primaryModals: item.primaryModels,
          primaryModalsIncentiveAmount: item.primaryIncentiveAmount,
          alternateModals:
            item?.brand?.toUpperCase() === 'MAZDA'
              ? getMazdaAlternateModelText(item.alternateModels)
              : getAlternateModels(item.alternateModels, item?.altIncentiveAmount),
          primaryAltModalsIncentiveAmount: item.altIncentiveAmount,
          excludedModals: item.exclusionModels.join(', '),
          brand: item.brand,
          isLeaseBuyOut: props.isLeaseBuyOut,
        };
      });

      setPrivateIncentiveDetails(incentives);
    }
    SetIsloading(false);
  };

  return (
    <div data-testid='note-modal' id='modalHandler'>
      {isLoading && <Loader />}
      <Modal
        isOpen={props.isModalOpen}
        onRequestClose={handleCloseNotesModal}
        contentLabel='Pil Modal'
        style={modalStyles}
        overlayClassName={'notes-modal-overlay'}
        ariaHideApp={false}
      >
        {privateIncentiveDetails.length > 0 && (
          <>
            <PrivateIncentiveModalTitle
              bgColor={theme.palette.text.white}
              title='Private Incentive'
              size={theme.typography.h4}
              color={theme.palette.black}
              fontWeight={theme.typography.fontWeights.semibold}
              iconColor={theme.palette.black}
              handleIconClick={handleCloseNotesModal}
              showCloseIcon={true}
            />
            <ModalBody>
              <PrivateIncentiveLookupSearchResult
                privateIncentiveDetails={privateIncentiveDetails}
                onSearchViewChange={() => {}}
                type={'modal'}
              />
            </ModalBody>
          </>
        )}
      </Modal>
    </div>
  );
};

export default PrivateIncentiveModal;

const ModalBody = styled.div`
  padding-right: 7.7%;
  margin-top: -20px;
`;

const modalStyles: Modal.Styles = {
  content: {
    top: '60px',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translateX(-50%)',
    maxWidth: '640px',
    zIndex: 205,
    padding: '0',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column' as 'column',
    border: 0,
    boxShadow: '0 5px 15px rgb(0 0 0 / 50%)',
    borderRadius: '8px 8px 6px 6px',
  },
};
